import React from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Numeric } from '@swyftx/aviary/atoms/Typography';

import { formatCurrency } from '@shared/utils';

import { observer } from 'mobx-react-lite';
import { useMarginPositionDetails } from 'src/lib/margin/hooks/positions';

import { MarginPositionsTableCurrentPrice } from './MarginPositionsTableCurrentPrice';

type Props = {
  positionId?: string;
};

const MarginPositionsTablePriceCurrentPrice: React.FC<Props> = observer(({ positionId }) => {
  const { position, priceScale } = useMarginPositionDetails({ positionId });

  if (!position) return null;

  return (
    <FlexLayout justifyContent='start' direction='column' alignItems='end'>
      <Numeric color='primary' weight='bold'>
        {formatCurrency(position.limitPrice || position.stopPrice || '-', undefined, { priceScale })}
      </Numeric>
      <MarginPositionsTableCurrentPrice positionId={positionId} />
    </FlexLayout>
  );
});

export { MarginPositionsTablePriceCurrentPrice };
